import React from "react"
import { useSwiperSlide } from "swiper/react"

import type { PostCardProps } from "../PostCard/PostCard"
import { PostCard } from "../PostCard/PostCard"

export type SliderItemProps = PostCardProps & {
  titleLevel?: 3 | 4
}

export const SliderItem = ({ image, titleLevel = 3, ...postCardProps }: SliderItemProps) => {
  const { isVisible, isNext, isPrev } = useSwiperSlide()
  const isLoaded = isVisible || isNext || isPrev

  return <PostCard image={isLoaded ? image : undefined} titleLevel={titleLevel} {...postCardProps} />
}
